module.exports = __webpack_public_path__ + "img/go.265cdedb.svg";